import { render } from "./Form.vue?vue&type=template&id=72e0174d&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=72e0174d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72e0174d"

export default script